module.exports = __webpack_public_path__ + "static/img/2389_phase_function_Paper_PointsHejduk_Prediction.e403b55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2389_phase_function_Paper_PointsHejduk_Prediction.png
// module id = YmPo
// module chunks = 0